import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { getDriverMileageByQueryThunk } from "../actions/get-driver-mileage.action";
import { IDriverMileageState } from "../driver-mileage.slice";

const getDriverMileageCases = (
  builder: ActionReducerMapBuilder<IDriverMileageState>
) => {
  builder.addCase(getDriverMileageByQueryThunk.pending, (state) => {
    state.loading = true;
  });
  builder.addCase(getDriverMileageByQueryThunk.fulfilled, (state, action) => {
    state.loading = false;
    state.driverMileageList = action.payload?.results || [];
    state.totalRecords = action.payload?.rowCount || 0;
  });
  builder.addCase(getDriverMileageByQueryThunk.rejected, (state) => {
    state.loading = false;
  });
};

export default getDriverMileageCases;
